module.exports = __webpack_public_path__ + "public/SideMenuIcons/precautionNotification.svg?78983fea";